import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const IscPartsCatalogs = () => {
  return (
    <MicroFrontEnd
      name="IscCatalogs"
      src={apiConfig.microFrontEnds.IscPartsCatalogs}
      props={{ catalogMode: 'parts' }}
    />
  )
}

export default IscPartsCatalogs
